import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import intl from './intl';
import { mapStateToProps } from './redux/language';
import CookieCampaign from './campaign/CookieCampaign';
import Site from './Site';

function App({ language, eventId }) {
  return (
    <IntlProvider {...intl(language)}>
      <CookieCampaign>
        <Site eventId={eventId} language={language} />
      </CookieCampaign>
    </IntlProvider>
  );
}

App.propTypes = {
  language: PropTypes.string.isRequired,
  eventId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js